import { connect } from 'react-redux';
import { get } from 'lodash';

import { QuickLoggedNav } from './QuickLoggedNav.jsx';

function mapStateToProps(state) {
  return {
    bookingId: get(state, 'memberSpace.quickLogin.bookingId'),
    stayId: get(state, 'memberSpace.quickLogin.stayId'),
  };
}

export const QuickLoggedNavContainer = connect(mapStateToProps)(QuickLoggedNav);
